import { FaCalendarDay, FaCalendarWeek } from 'react-icons/fa6';
import { FaCamera, FaFileUpload, FaUser, FaSearch, FaFileSignature, FaClock, FaSignOutAlt } from 'react-icons/fa';
import { MdSchool } from 'react-icons/md';
import { PiArrowRightBold, PiBriefcaseDuotone, PiShoppingCartDuotone, PiDeviceMobileCameraDuotone, PiThumbsUpDuotone, PiCrownSimpleDuotone, PiCameraDuotone } from "react-icons/pi";
import { useNavigate } from 'react-router-dom';

import { useAuth } from 'providers/AuthProvider';
import { useWebsite } from 'providers/WebsiteProvider';

import { getGreetingByTime } from 'utils/GenericUtils';

export default function ProfileBar(props) {
    const navigate = useNavigate();
    const { setProfileOpen } = useWebsite();

    const closeOnMobile = () => {
        if (window.matchMedia('(max-width: 1023px)').matches) {
            setProfileOpen(false);
        }
    };

    return (
        <div className={'fixed top-0 w-72 h-dvh py-4 ' + (props.className || '')}>

            <div className='w-full h-full flex flex-col rounded-r-3xl overflow-hidden'>

                <Header />
                <div className='theme-scrollbar -mb-6 -mt-6 flex min-h-0 flex-1 flex-col gap-4 overflow-y-scroll bg-neutral-700 p-4 pb-12 pt-10 shadow-2xl'>

                    <FunctionList onModeChange={(mode) => {
                        console.log('FunctionList mode change:', mode);
                        if (mode === 'PERSONAL') {
                            navigate("/formpage?blockList=personal");
                        } else if (mode === 'PICTURE') {
                            navigate("/formpage?blockList=picture");
                        }else if (mode === 'CV') {
                            navigate("/formpage?blockList=cv");
                        }else if (mode === 'PREFERENCES') {
                            navigate("/formpage?blockList=preferences");
                        }else if (mode === 'STUDY') {
                            navigate("/formpage?blockList=study");
                        }else if (mode === 'CONTRACT') {
                            navigate("/formpage?blockList=contract");
                        }else if (mode === 'MONTHLY_INCOME_ACCOUNTING') {
                            navigate("/formpage?blockList=monthly_income_accounting");
                        }else if (mode === 'YEARLY_INCOME_ACCOUNTING') {
                            navigate("/formpage?blockList=yearly_income_accounting");
                        }else if (mode === 'DigitalAttendanceScreen') {
                            navigate("/digitalis-jelenleti-iv");
                        }else if (mode === 'STUDENT_JOB_APPOINTMENT') {
                            navigate("/studentJobAppointment");
                        }else if (mode === 'SHOP') {
                            navigate("/shop");
                        }else if (mode === 'APP_DOWNLOAD') {
                            navigate("/diak-bejelentkezett-legyapprakesz");
                        }else if (mode === 'SATISFACTION_MEASUREMENT') {
                            navigate("/diak-bejelentkezett-elegedettsegmeres");
                        }
                        closeOnMobile();
                    }} />
                </div>
                <MenuList />
            </div>

        </div>
    );
}

function Header(props) {
    const { userData } = useAuth();
    const { setProfileOpen } = useWebsite();
    const navigate = useNavigate();

    const profilePictureUrl = userData?.photoKey
        ? `${global.backingsEndpoint}photoRepository/getImageBySize?size=ORIGINAL&key=${userData.photoKey}`
        : null;

    const handleProfilePictureClick = () => {
        navigate("/formpage?blockList=picture");
        if (window.matchMedia('(max-width: 1023px)').matches) setProfileOpen(false);
    };

    const handleJobsClick = () => {
        navigate("/diakmunka");
        if (window.matchMedia('(max-width: 1023px)').matches) setProfileOpen(false);
    };

    return (
        <div className="gradient-green flex flex-col items-center gap-4 rounded-r-3xl p-4 z-10">
            <div className='flex items-center gap-4'>
                <div className="flex-1 flex flex-col gap-4 items-start justify-between">
                    <div className="flex flex-col gap-1.5">
                        <div className="font-display font-bold text-lg leading-none text-white">
                            {getGreetingByTime()} {userData?.firstName || "User"}!
                        </div>
                        <div className="text-[10px] leading-none text-white/50">
                            {userData?.email || "N/A"}
                        </div>
                    </div>

                    <div className="flex items-center gap-1.5 px-2 py-0.5 rounded-lg gradient-yellow text-white">
                        <PiCrownSimpleDuotone className="text-xs" />
                        <div className="font-display font-medium text-xs">Fürge Club - VIP tag</div>
                    </div>
                </div>

                <button className="size-20 flex items-center justify-center bg-white/10 rounded-2xl transition hover:ring-4 ring-white/20"
                        onClick={handleProfilePictureClick}>
                    {profilePictureUrl ? (
                        <img
                            src={profilePictureUrl}
                            alt="Profile"
                            className="rounded-2xl w-full h-full object-cover"
                        />
                    ) : (
                        <PiCameraDuotone className="text-4xl text-white/30" />
                    )}
                </button>
            </div>
            <button
                className='group flex w-full items-center gap-3 overflow-hidden rounded-2xl bg-white p-2.5 text-left text-neutral-900 shadow-xl ring-4 ring-white/15 transition hover:-translate-y-0.5 hover:ring-white/30 hover:shadow-2xl'
                onClick={handleJobsClick}
            >
                <span className='gradient-blue flex size-10 shrink-0 items-center justify-center rounded-xl text-white shadow-md'>
                    <PiBriefcaseDuotone className='size-6' />
                </span>
                <span className='min-w-0 flex-1'>
                    <strong className='block font-display text-base font-black leading-tight'>Diákmunkák</strong>
                    <span className='block text-[10px] font-semibold text-neutral-500'>Találd meg a következő munkádat</span>
                </span>
                <PiArrowRightBold className='mr-1 size-4 text-sky-500 transition group-hover:translate-x-1' />
            </button>
        </div>
    );
}

function MenuList() {
    const { logout } = useAuth();

    return (
        <div className='relative z-20 flex w-full flex-col gap-2 rounded-r-3xl bg-neutral-600 p-4 pt-6 shadow-2xl'>
            <MenuItem
                data={{ 'label': 'Kijelentkezés', 'className': 'gradient-red', 'icon': <FaSignOutAlt /> }}
                onClick={logout}
            />
        </div>
    );
}

function MenuItem(props) {
    return (
        <button 
            onClick={props.onClick}
            className={'rounded-xl bg-white/10 shadow-2xl px-4 py-2 text-white flex items-center gap-2 active:scale-95 transition ' + (props.data.className || '')}>

            <div className='flex-1 font-display font-bold  text-sm text-left'>{props.data.label}</div>

            <div>{props.data.icon}</div>

        </button>
    );
}

function FunctionList(props) {
    const modeList = [
        {
            'label': 'Adataim', 'className': 'gradient-green', 'key': 'PERSONAL', 'modeList': [
                { 'label': 'Profilképem', 'mode': 'PICTURE', 'icon': <FaCamera />, 'completionPercentage': [{ 'key': 'photoPercent', 'value': 10 }] },
                { 'label': 'Önéletrajzom', 'mode': 'CV', 'icon': <FaFileUpload />, },
                { 'label': 'Személyes adataim', 'mode': 'PERSONAL', 'icon': <FaUser />, 'completionPercentage': [{ 'key': 'contactPercent', 'value': 5 }, { 'key': 'addressPercent', 'value': 5 }] },
                // { 'label': 'Jelszavam', 'mode': 'PASSWORD', 'icon': <FaLock /> },
                { 'label': 'Tanulmányaim, képességeim', 'mode': 'STUDY', 'icon': <MdSchool />, 'completionPercentage': [{ 'key': 'studiesPercent', 'value': 3 }, { 'key': 'schoolPercent', 'value': 2 }, { 'key': 'languagePercent', 'value': 3 }, { 'key': 'drivingPercent', 'value': 2 }] },
                { 'label': 'Szerződéskötés és digitális ügyintézés', 'mode': 'CONTRACT', 'icon': <FaFileSignature />, 'completionPercentage': [{ 'key': 'contractingPercent', 'value': 10 }] },
                { 'label': 'Munkakeresési szempontjaim', 'mode': 'PREFERENCES', 'icon': <FaSearch /> },
            ]
        },
        {
            'label': 'Jövedelem elszámolásaim', 'className': 'gradient-blue', 'key': 'INCOME_ACCOUNTING', 'modeList': [
                { 'label': 'Havi elszámolásaim', 'mode': 'MONTHLY_INCOME_ACCOUNTING', 'icon': <FaCalendarDay /> },
                { 'label': 'Éves elszámolásaim', 'mode': 'YEARLY_INCOME_ACCOUNTING', 'icon': <FaCalendarWeek /> }
            ]
        },
        {
            'label': 'Jelenléti íveim', 'className': 'gradient-yellow', 'key': 'DIGITAL_ATTENDANCE', 'modeList': [
                { 'label': 'Digitális jelenléti íveim', 'mode': 'DigitalAttendanceScreen', 'icon': <FaClock /> },
                { 'label': 'Diákmunka időpontfoglalás', 'mode': 'STUDENT_JOB_APPOINTMENT', 'icon': <FaCalendarDay /> },
            ]
        },
        {
            'label': 'További lehetőségek', 'className': 'gradient-red', 'key': 'MORE', 'modeList': [
                { 'label': 'Shop', 'mode': 'SHOP', 'icon': <PiShoppingCartDuotone /> },
                { 'label': 'App letöltése', 'mode': 'APP_DOWNLOAD', 'icon': <PiDeviceMobileCameraDuotone /> },
                { 'label': 'Elégedettségmérés', 'mode': 'SATISFACTION_MEASUREMENT', 'icon': <PiThumbsUpDuotone /> },
            ]
        },
    ]

    return (
        <div className='flex flex-col gap-4'>
            {modeList.map((item) => <FunctionBlock key={item.key} data={item} onModeChange={(mode) => props.onModeChange(mode)} />)}
        </div>
    );
}

function FunctionBlock(props) {
    return (
        <div className={'w-full flex flex-col gap-2 rounded-2xl p-4 shadow-2xl ' + (props.data.className)}>

            <div className='font-display font-bold text-white text-lg'>{props.data.label}</div>

            <div className='flex flex-col gap-2'>
                {props.data.modeList.map((item) => <FunctionButton key={item.label} data={item} onPress={() => props.onModeChange(item.mode)} />)}
            </div>

        </div>
    );
}

function FunctionButton(props) {
    return (
        <button 
            className={'w-full flex items-center gap-2.5 rounded-lg px-3 py-2 bg-white/20 hover:bg-white/30 active:scale-95 transition ' + (props.data.className)}
            onClick={props.onPress}
        >
            <div className='text-white text-xs'>{props.data.icon}</div>
            <div className='font-semibold text-white text-xs text-left'>{props.data.label}</div>
        </button>
    );
}
